<template>
  <div class='chart-wrapper'></div>
</template>

<script>

	import BrushChart from '../../charts/brushchart'
	import {select} from 'd3';

	export default {
		name: "BrushChart",
		props: ["chartdata"],
		data: function () {
			return {
				chart: null,
			}
		},
		methods: {
			drawChart: function () {
				return new BrushChart({
					data: this.chartdata,
					selection: select(this.$el)
				})
			}
		},
		mounted() {
			this.chart = this.drawChart();
		},
		watch: {
			chartdata() {
				this.chart.update({
          data: this.chartdata
        })
			}
		}

	}
</script>

<style lang="less" scoped>

  .axis--y {
     opacity: .4;
  }


</style>
